<template>
    <div>
        <div class="card">
            <div v-if="group.homepage" class="flex items-center">
                <div>
                    <span class="icon-circle bg-neutral-lightest">
                        <font-awesome-icon icon="link" />
                    </span>
                    <span class="ml-md">
                        <a
                            :href="group.homepage"
                            target="_blank"
                            rel="nofollow noopener"
                        >
                            {{ group.homepage }}
                        </a>
                    </span>
                </div>
                <div class="ml-auto flex">
                    <button
                        class="btn-icon hover:bg-danger hover:border-danger"
                        @click="deleteHomepage"
                    >
                        <font-awesome-icon icon="trash-alt" size="xs" />
                    </button>
                    <button
                        class="btn-icon"
                        @click="$modal.show('edit-homepage')"
                    >
                        <font-awesome-icon icon="pencil" size="sm" />
                    </button>
                </div>
            </div>
            <div v-else class="flex items-center">
                <div>
                    <span class="icon-circle bg-neutral-lightest">
                        <font-awesome-icon icon="link" />
                    </span>
                    <span class="ml-md">Länk till webbplats</span>
                </div>
                <div class="ml-auto">
                    <button class="btn btn-icon is-primary" @click="$modal.show('edit-homepage')">
                        <font-awesome-icon icon="plus" size="xs" />
                    </button>
                </div>
            </div>
        </div>

        <adaptive-form-modal
            name="edit-homepage"
            primary-button-text="Uppdatera webbplats"
            primary-button-class="is-primary"
            title="Länk till webbplats"
            method="patch"
            :action="route('api.sales-projects.groups.homepage.update', [project, group])"
            :callback="handleUploadCallback"
        >
            <text-input
                type="url"
                name="homepage"
                :value="group.homepage"
                :autofocus="true"
                :required="true"
                label="Webbplats (inkl. https://)"
            />
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                required: true,
                type: Object,
            },
            initialGroup: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                group: this.initialGroup,
            };
        },
        methods: {
            deleteHomepage() {
                axios.delete(route('api.sales-projects.groups.homepage.destroy', [this.project, this.group]))
                    .then((response) => {
                        this.group = response.data.group;
                    })
                    .catch(error => {
                        flash_error('Kunde inte ta bort länken');
                    });
            },
            handleUploadCallback({ data }) {
                flash_success('Länk till webbplats uppdaterad!');
                this.group = data.group;
                this.$modal.hide('edit-homepage');
            },
        },
    };
</script>
